// Modal de ajuda por tela e menu do usuario.
//
// O modal de CONTA (Desbloquear/Conta/Nuvem/Carreiras/CEO) mora em
// account-modal.jsx -- e grande o bastante para ter arquivo proprio.

import React, { useEffect } from 'react';
import { HELP } from './help-content.js';
import { PREMIUM } from './premium-config.js';
import { esquecerTelasVistas } from './help-content.js';
import { cloudVersion, cloudLastAt } from './cloud.js';

// =============================================================== AJUDA =====
export function HelpButton({ screen, onOpen }) {
  if (!HELP[screen]) return null;
  return (
    <button className="help-btn" onClick={() => onOpen(screen)} aria-label="O que e esta tela">
      ?
    </button>
  );
}

export function HelpModal({ screen, onClose }) {
  const help = HELP[screen];
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);
  if (!help) return null;

  return (
    <div className="backdrop" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="modal">
        <div className="row spread" style={{ marginBottom: 4 }}>
          <p className="kicker">• Como funciona</p>
          <button className="ghost sm" onClick={onClose}>fechar</button>
        </div>
        <h1 style={{ marginBottom: 6 }}>{help.title}</h1>
        <p className="muted small" style={{ marginTop: 0 }}>{help.lead}</p>

        <div className="help-list">
          {help.topics.map(([titulo, texto]) => (
            <div key={titulo} className="help-item">
              <div className="help-item-t">{titulo}</div>
              <div className="help-item-d">{texto}</div>
            </div>
          ))}
        </div>

        <button className="primary" style={{ width: '100%', marginTop: 14 }} onClick={onClose}>
          entendi
        </button>
      </div>
    </div>
  );
}

// ========================================================= MENU DO USUARIO =
export function UserMenu({
  account, premium, onAccount, onPremium, onHowTo, onLogout, onClose, onCeo, resumo,
}) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div className="backdrop" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="modal">
        <div className="row spread" style={{ marginBottom: 12 }}>
          <h1>Sua conta</h1>
          <button className="ghost sm" onClick={onClose}>fechar</button>
        </div>

        <div className="user-card">
          <div className="user-avatar">{(account?.email || '?')[0].toUpperCase()}</div>
          <div style={{ minWidth: 0 }}>
            <div style={{ fontWeight: 700, overflowWrap: 'anywhere' }}>
              {account ? account.email : 'Voce nao entrou'}
            </div>
            <div className="small dim">
              {account
                ? (premium ? `${PREMIUM.name} ativo` : 'Conta gratis')
                /* ⚠️ Esta linha e o que muita gente le no momento em que
                   decide se cria conta ou nao -- e uma das portas para ca e o
                   desafio da semana, que desde 07/09/2026 exige cadastro.
                   Dizer so "serve para o premium" faz a conta parecer coisa de
                   quem vai pagar, e quem veio pelo desafio desiste ali. */
                : 'A carreira roda sem conta. A conta libera o desafio da semana, o save na nuvem e o premium em qualquer aparelho.'}
            </div>
          </div>
        </div>

        <PainelDoUsuario account={account} premium={premium} resumo={resumo} />

        <div className="grid" style={{ gap: 8, marginTop: 12 }}>
          {!account && (
            <button className="cta" onClick={onAccount}>
              <span className="ic">👤</span>
              <span><span className="tt">Entrar ou criar conta</span>
                <span className="ss">Leva o premium para o celular e o computador</span></span>
              <span className="arrow">›</span>
            </button>
          )}
          {!premium && (
            <button className="cta dark" onClick={onPremium}>
              <span className="ic">🔓</span>
              <span><span className="tt">{PREMIUM.name} · {PREMIUM.priceLabel}</span>
                <span className="ss">{PREMIUM.pitch}</span></span>
              <span className="arrow">›</span>
            </button>
          )}
          <button className="cta dark" onClick={onHowTo}>
            <span className="ic">📘</span>
            <span><span className="tt">Como jogar</span>
              <span className="ss">O guia completo do jogo</span></span>
            <span className="arrow">›</span>
          </button>
          {account && onCeo && (
            <button className="cta dark" onClick={onCeo}>
              <span className="ic">📈</span>
              <span><span className="tt">Painel CEO</span>
                <span className="ss">Contas, vendas e suporte</span></span>
              <span className="arrow">›</span>
            </button>
          )}
          {account && (
            <button className="danger" onClick={onLogout}>sair desta conta</button>
          )}
        </div>
      </div>
    </div>
  );
}


/**
 * PAINEL DO USUÁRIO: o que é dele, num lugar só.
 *
 * Antes o menu da conta só dizia o e-mail e o que dava para comprar. Quem
 * queria saber quantas temporadas jogou, quantos títulos tem ou se o save
 * subiu para a nuvem precisava caçar em três telas diferentes.
 *
 * Os números da carreira vêm de fora (`resumo`) porque este modal também abre
 * na tela inicial, quando não há carreira carregada na memória.
 */
function PainelDoUsuario({ account, premium, resumo }) {
  const versao = cloudVersion();
  const ultimo = cloudLastAt();
  const quando = (iso) => {
    if (!iso) return 'nunca';
    try {
      return new Date(iso).toLocaleString('pt-BR', {
        day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit',
      });
    } catch { return 'nunca'; }
  };

  return (
    <div className="card" style={{ marginTop: 12 }}>
      <h3>Seus dados</h3>

      <div className="grid two small">
        <div className="row spread">
          <span className="dim">Conta</span>
          <b>{account ? (premium ? PREMIUM.name : 'Grátis') : 'sem conta'}</b>
        </div>
        <div className="row spread">
          <span className="dim">Nome</span>
          <b>{account?.nome || '-'}</b>
        </div>
        <div className="row spread">
          <span className="dim">WhatsApp</span>
          <b>{account?.whatsapp || '-'}</b>
        </div>
        <div className="row spread">
          <span className="dim">Save na nuvem</span>
          <b>{!account ? '-' : !premium ? 'no premium' : versao ? `versão ${versao}` : 'ainda não'}</b>
        </div>
        {account && premium && (
          <div className="row spread">
            <span className="dim">Último envio</span>
            <b>{quando(ultimo)}</b>
          </div>
        )}
      </div>

      {resumo ? (
        <>
          <h3 style={{ marginTop: 14 }}>Sua carreira</h3>
          <div className="grid two small">
            <div className="row spread"><span className="dim">Clube</span><b>{resumo.clube}</b></div>
            <div className="row spread"><span className="dim">Liga</span><b>{resumo.liga}</b></div>
            <div className="row spread"><span className="dim">Temporada</span><b>{resumo.temporada}</b></div>
            <div className="row spread"><span className="dim">Campanha</span><b>{resumo.campanha}</b></div>
            <div className="row spread"><span className="dim">Títulos</span><b className="gold">{resumo.titulos}</b></div>
            <div className="row spread"><span className="dim">Troféus</span><b>{resumo.trofeus}</b></div>
          </div>
        </>
      ) : (
        <div className="small dim" style={{ marginTop: 10 }}>
          Nenhuma carreira neste aparelho ainda.
        </div>
      )}

      <button className="ghost sm" style={{ width: '100%', marginTop: 12 }}
        onClick={() => { esquecerTelasVistas(); window.alert('As explicações de tela vão aparecer de novo.'); }}>
        ver as explicações de tela de novo
      </button>
    </div>
  );
}
